import { Outlet, useLocation } from "react-router-dom";
import { Header } from "./Header";
import { Navbar } from "./Navbar";
import { ViewportModal } from "./ViewportModal";
import { twJoin } from "tailwind-merge";

export const Layout = () => {
  const { pathname } = useLocation();

  const isLoginPage = pathname === "/login";
  return (
    <div>
      <ViewportModal />
      {!isLoginPage && (
        <>
          <Navbar />
          <Header />
        </>
      )}
      <main className={twJoin(!isLoginPage && "ml-20 z-20")}>
        <Outlet />
      </main>
    </div>
  );
};
